import type { JSX } from 'preact';
import { ThinkingIcon } from './icons';

/**
 * Shown while the bookseller is composing a reply: a gently pulsing open-book
 * icon with a wave of dots, so the customer sees it is thinking, not stalled.
 */
export function TypingIndicator(): JSX.Element {
  return (
    <div class="sa-typing" role="status" aria-label="المساعد يفكّر…">
      <span class="sa-typing__icon">
        <ThinkingIcon />
      </span>
      <span class="sa-typing__dots">
        <span />
        <span />
        <span />
      </span>
    </div>
  );
}
